// EVENTS : CHARGEMENT DU DOCUMENT
jQuery(document).ready(function() {
    //wc
    /*
    jQuery('.woocommerce-tabs a').unbind('click').click(function(event ){
        event.preventDefault();
        jQuery('.woocommerce-tabs li').removeClass('active');
        jQuery('.woocommerce-tabs .woocommerce-Tabs-panel').slideUp();

        jQuery(this).parent().toggleClass('active');
        var id = jQuery(this).attr('href');
        jQuery(id).stop().slideToggle();
        return false;
    });
    */

    jQuery( document ).on( 'removed_from_cart updated_cart_totals', function(){

        var qty = 0;
        jQuery( '.header__widgetsarea .woocommerce-mini-cart-item-description--quantity .nb span' ).each(function(){
            var nb = parseInt( jQuery(this).text() );
            qty+=nb;
        });

        jQuery( '.count-cart' ).text(qty);
    });

    jQuery('.thwepo-extra-options .label-tag').css('cursor','pointer').click(function(){
        jQuery(this).parent().find('input').trigger('click');
    });


    jQuery('form.cart input.qty').each(function(){
        let $input = jQuery(this);

        jQuery($input).wrap('<div class="js-qty-container"></div>');
        let $container = jQuery(this).parent();

        jQuery('<button type="button" class="minus" >-</button>').prependTo($container);
        jQuery('<button type="button" class="plus" >+</button>').appendTo($container);

        jQuery($container).find('button.minus,button.plus').click(function(){
            // Get current quantity values
            var qty = jQuery( this ).parent().find( '.qty' );
            var val   = parseFloat(qty.val());
            var max = parseFloat(qty.attr( 'max' ));
            var min = parseFloat(qty.attr( 'min' ));
            var step = parseFloat(qty.attr( 'step' ));

            if( !val ) val = 0;

            // Change the value if plus or minus
            if ( jQuery( this ).is( '.plus' ) ) {
                if ( max && ( max <= val ) ) {
                    qty.val( max );
                }
                else {
                    qty.val( val + step );
                }
            }
            else {
                if ( min && ( min >= val ) ) {
                    qty.val( min );
                }
                else if ( val > 0 ) {
                    qty.val( val - step );
                }
            }

            qty.trigger('change');
        });
    });

    jQuery('.modal-success-add-to-cart').addClass('active');
    jQuery('.modal-success-add-to-cart__btn-close, .modal-success-add-to-cart__overlay').click(function(){
        jQuery(this).parents().removeClass('active');
    });

});

// EVENTS : SCROLL
jQuery(window).scroll(function() {

});

// EVENTS : RESIZE
jQuery(window).resize(function() {

});